import type { ElectricityHeatSteamConsumptionDataPayload } from '/business/shared/state/selectors/application/electricityHeatSteam/electHeatSteamTypes';

import ValidationError from '/shared/errors/ValidationError';
import normaliseError, { toNormaliseErrorInput } from '/shared/functions/normaliseError';
import type { AppDispatch } from '/business/shared/state/store';

import saveItem from '/business/shared/state/actions/basket/saveItem';
import { getFormState } from '/business/shared/state/actions/application';

type ElectricityHeatSteamConsumptionBasketItem = {
  id?: number | null;
  genericData: ElectricityHeatSteamConsumptionDataPayload;
};

const saveConsumptionData =
  ({
    basketItem,
    applicationId,
    isDelete = false,
  }: {
    basketItem: ElectricityHeatSteamConsumptionBasketItem;
    applicationId: number;
    isDelete?: boolean;
  }) =>
  async (dispatch: AppDispatch) => {
    const itemId = basketItem?.id || undefined;
    let questionTypeKey: string | false = false;
    if (basketItem.genericData.flag_type === 'heating') {
      questionTypeKey = 'calc-elect-consumption-flag-heat';
    } else if (basketItem.genericData.flag_type === 'steam') {
      questionTypeKey = 'calc-elect-consumption-flag-steam';
    } else if (basketItem.genericData.flag_type === 'electricity') {
      questionTypeKey = 'calc-elect-consumption-flag-elect';
    }
    if (!questionTypeKey) {
      return null;
    }
    const startedReduxCode = !itemId ? 'BASKET_ADD_STARTED' : 'BASKET_UPDATE_STARTED';
    const rejectCode = !itemId ? 'BASKET_ADD_REJECTED' : 'BASKET_UPDATE_REJECTED';
    const fulfillCode = !itemId ? 'BASKET_ADD_FULFILLED' : 'BASKET_UPDATE_FULFILLED';

    try {
      await dispatch({ type: startedReduxCode, item: { created: new Date(), itemId, questionTypeKey } });
      const item = await dispatch(
        saveItem({
          isDelete,
          basketItem: {
            ...basketItem,
            itemId,
            isBulk: false,
            type: questionTypeKey,
          },
          applicationId,
        }),
      );
      await dispatch({ type: fulfillCode, item });
      await dispatch(getFormState(applicationId));
      return item;
    } catch (error) {
      if (error instanceof ValidationError) {
        await dispatch({ type: rejectCode, error });
      } else {
        await dispatch({ type: rejectCode, error: normaliseError(toNormaliseErrorInput(error), 'BASKET') });
      }
      throw error;
    }
  };

export default saveConsumptionData;
